//热点聚焦
import React from 'react';
import './BIM.scss';
import { RelatedCases } from '@/components'
import { HeaderSwiper } from '@/components/mixins'
class BIM extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      navSwiper: '',
      bannerImages: [
        { imgPath: require("img/Products/BIMbg.png"), imgHDPath: `${require("img/Products/BIMbg.png")} 1x,${require("img/Products/BIMbg@2x.png")} 2x,${require("img/Products/BIMbg@3x.png")} 3x`, attachURL: "/" },
      ],
      productList: [
        {
          imgPath: require("img/Products/BIMicon.png"), imgHDPath: `${require("img/Products/BIMicon.png")} 1x,${require("img/Products/BIMicon@2x.png")} 2x,${require("img/Products/BIMicon@3x.png")} 3x`,
          title: '全过程BIM服务'
        },
        {
          imgPath: require("img/Products/BIMicon.png"), imgHDPath: `${require("img/Products/BIMicon.png")} 1x,${require("img/Products/BIMicon@2x.png")} 2x,${require("img/Products/BIMicon@3x.png")} 3x`,
          title: '业主BIM实施顾问'
        },
        {
          imgPath: require("img/Products/BIMicon.png"), imgHDPath: `${require("img/Products/BIMicon.png")} 1x,${require("img/Products/BIMicon@2x.png")} 2x,${require("img/Products/BIMicon@3x.png")} 3x`,
          title: '企业BIM解决方案'
        },
        {
          imgPath: require("img/Products/BIMicon.png"), imgHDPath: `${require("img/Products/BIMicon.png")} 1x,${require("img/Products/BIMicon@2x.png")} 2x,${require("img/Products/BIMicon@3x.png")} 3x`,
          title: '宣传片、VR、AR、内容制作'
        },
        {
          imgPath: require("img/Products/BIMicon.png"), imgHDPath: `${require("img/Products/BIMicon.png")} 1x,${require("img/Products/BIMicon@2x.png")} 2x,${require("img/Products/BIMicon@3x.png")} 3x`,
          title: 'BIM软件开发'
        },
        {
          imgPath: require("img/Products/BIMicon.png"), imgHDPath: `${require("img/Products/BIMicon.png")} 1x,${require("img/Products/BIMicon@2x.png")} 2x,${require("img/Products/BIMicon@3x.png")} 3x`,
          title: 'BIM课题研究与标准研究'
        },
      ],
      serverList: [
        {
          title: '设计阶段BIM服务',
          data: '提供方案优化、场布优化、建筑性能分析服务，施工图阶段进行施工图“零错误、零变更”优化并出图，配合设计方形成全过程三维可视化设计、三维优化，大幅提升设计质量，从源头把控投资。'
        },
        {
          title: '施工阶段BIM服务',
          data: '利用青矩BIM云管理平台进行施工阶段全过程项目管理，包括质量、安全、进度、成本等，实现可视化、信息化管理升级；通过施工模拟验证施工方案，通过可视化交底提升技术交底功效水平，通过BIM应用提升管理和技术水平。'
        },
        {
          title: '全过程BIM实施顾问',
          data: '作为BIM总控协调方提供项目的全过程BIM体系策划、标准制定、技术指导、过程监督、实施评价，辅助设计方、施工方自主使用BIM技术，并通过协调管理形成统一、规范的全过程BIM成果，切实保障BIM应用规范、合理、高效。'
        },
        {
          title: "企业BIM解决方案",
          data: '针对企业自身业务情况，定制企业BIM发展策划，辅助企业建立BIM团队、搭建软硬件系统、规划BIM运营体系，并提供定制化培训，切实解决企业BIM发展过程中方向不清楚、技术不专业、业务不融合等痛点。'
        },
        {
          title: "BIM软件开发",
          data: '开发具备轻量化、物联网、多端协同等特色的BIM协同管理平台、BIM运维平台，服务于工程项目管理及运维全过程，并提供BIM协同平台定制化开发服务。'
        },
        {
          title: "BIM课题研究及标准研究",
          data: '依托大量BIM咨询项目经验，开展BIM相关的技术研究，包括课题研究，以及行业、企业、项目标准编制等。'
        },
        {
          title: "宣传片、VR、AR、电子沙盘制作",
          data: '提供工程动画制作、宣传片制作服务，利用BIM模型进行VR、AR、电子沙盘制作。'
        }
      ],
      caseList: [
        { imgs: require("img/Products/BIMpic1.png"), name: "许昌市中心医院新院区医技病房综合楼" },
        { imgs: require("img/Products/BIMpic2.png"), name: "长沙轨道交通4号线一期工程" },
        // { imgs: require("img/Products/BIMpic4.png"), name: "思茅至澜沧高速公路" },
        // { imgs: require("img/Products/BIMpic3.png"), name: "石家庄勒泰中心" },
        // { imgs: require("img/Products/BIMpic5.png"), name: "交通银行河南省分行档案管理中心" },

        { imgs: require("img/Products/BIMpic6.png"), name: "国开新能源东乡光伏电站" },
        { imgs: require("img/Products/BIMpic7.png"), name: "内蒙古康巴什电厂" },
        { imgs: require("img/Products/BIMpic8.png"), name: "上海迪士尼斯汀项目概念图" },
        { imgs: require("img/Products/BIMpic9.png"), name: "云南召泸高速公路工程" },
        { imgs: require("img/Products/BIMpic10.png"), name: "中节能风电BIM课题研究" },
      ]

    }

  }
  render() {
    return (
      <div className='BIM' >
        <main className="ContactUs-body">

          <HeaderSwiper headerDataLists={this.state.bannerImages}></HeaderSwiper>
          <div className='BIM-product'>
            <h5>主要产品</h5>
            <ul>
              {
                this.state.productList.map((item, index) =>
                  <li key={index}>
                    <div>
                      <img src={item.imgPath} alt="" srcSet={item.imgHDPath} />
                      <span>{item.title}</span>
                    </div>
                  </li>
                )
              }
            </ul>
          </div>
          <div className='BIM-count'>
            <h5>服务内容</h5>
            {
              this.state.serverList.map((item, index) =>
                <div key={index} className='BIM-count-server'>
                  <p><i></i><span>{item.title}</span></p>
                  <div>{item.data}</div>
                </div>
              )
            }
          </div>
          <RelatedCases caseList={this.state.caseList} id={'bim'} />
        </main>
      </div>
    )
  }
}
export default BIM;
